export default "__VITE_ASSET__BPpZlJCj__"